import { createSlice } from '@reduxjs/toolkit';

// Announcements admin state (Marketing > Pop-ups screen) + the org's help-desk requests
// (Tasks > Help Desk screen), mirroring store/tasks/tasksSlice.js: one loading/error surface,
// list mutations only from thunk success actions.
const initialState = {
  announcements: [],
  helpDeskRequests: [],
  isLoading: false,
  error: null
};

const announcementsSlice = createSlice({
  name: 'announcements',
  initialState,
  reducers: {
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchAnnouncementsSuccess: (state, action) => {
      state.announcements = action.payload;
      state.isLoading = false;
    },
    createAnnouncementSuccess: (state, action) => {
      state.announcements.unshift(action.payload);
      state.isLoading = false;
    },
    updateAnnouncementSuccess: (state, action) => {
      state.announcements = state.announcements.map(announcement =>
        announcement.id === action.payload.id ? action.payload : announcement
      );
      state.isLoading = false;
    },
    deleteAnnouncementSuccess: (state, action) => {
      state.announcements = state.announcements.filter(
        announcement => announcement.id !== action.payload
      );
      state.isLoading = false;
    },
    fetchHelpDeskRequestsSuccess: (state, action) => {
      state.helpDeskRequests = action.payload;
      state.isLoading = false;
    },
    createHelpDeskRequestSuccess: (state, action) => {
      state.helpDeskRequests.unshift(action.payload);
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchAnnouncementsSuccess,
  createAnnouncementSuccess,
  updateAnnouncementSuccess,
  deleteAnnouncementSuccess,
  fetchHelpDeskRequestsSuccess,
  createHelpDeskRequestSuccess
} = announcementsSlice.actions;

export default announcementsSlice.reducer;
